import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import { useTheme } from '../../theme/ThemeContext';

interface SessionExpiringModalProps {
  open: boolean;
  onStayLoggedIn: () => void;
  onLogout: () => void;
}

const SessionExpiringModal: React.FC<SessionExpiringModalProps> = ({ open, onStayLoggedIn, onLogout }) => {
  const { themeName } = useTheme();

  return (
    <Dialog
      open={open}
      disableEscapeKeyDown
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          border: themeName === 'light' ? '1px solid #EFEEF7' : '1px solid #5547DD',
        },
      }}
    >
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={2}>
          <WarningIcon color="warning" sx={{ fontSize: 28 }} />
          <Typography variant="h6" fontWeight={600}>
            Session Expiring Soon
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent>
        <Box textAlign="center" py={2}>
          <Typography variant="body2" color="text.secondary">
            Click "Stay Logged In" to continue your session, or you will be automatically logged out.
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ p: 3, gap: 2 }}>
        <Button
          onClick={onLogout}
          variant="outlined"
          color="inherit"
          sx={{
            minWidth: 120,
            borderColor: themeName === 'light' ? '#EFEEF7' : '#5547DD',
            color: themeName === 'light' ? '#333' : '#fff',
          }}
        >
          Logout Now
        </Button>

        <Button
          onClick={onStayLoggedIn}
          variant="contained"
          color="primary"
          sx={{
            minWidth: 140,
            backgroundColor: '#5547DD',
            '&:hover': {
              backgroundColor: '#4435CC',
            },
          }}
        >
          Stay Logged In
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SessionExpiringModal;
